import React from 'react';
import { FaSearch, FaTools, FaRocket, FaHeadset, FaChartLine } from 'react-icons/fa';

const Workflow: React.FC = () => {
  const steps = [
    {
      icon: <FaSearch className="text-white text-3xl" />,
      number: 1,
      title: 'Définition de la cible',
      description: 'Nous identifions ensemble votre client idéal et définissons les critères précis pour cibler les prospects les plus pertinents pour votre activité.'
    },
    {
      icon: <FaTools className="text-white text-3xl" />,
      number: 2,
      title: 'Création des assets de prospection',
      description: 'Nous élaborons des messages d\'accroche personnalisés, des séquences d\'emails et des scripts d\'appel adaptés à votre offre et à votre cible.'
    },
    {
      icon: <FaRocket className="text-white text-3xl" />,
      number: 3,
      title: 'Lancement de la prospection multi-canal',
      description: 'Nous activons simultanément plusieurs canaux de prospection (email, LinkedIn, téléphone) pour maximiser les chances de toucher vos prospects.'
    },
    {
      icon: <FaHeadset className="text-white text-3xl" />,
      number: 4,
      title: 'Suivi et Qualification',
      description: 'Nous assurons le suivi des réponses, qualifions les opportunités et organisons les rendez-vous directement dans votre agenda.'
    },
    {
      icon: <FaChartLine className="text-white text-3xl" />,
      number: 5,
      title: 'Analyse & Optimisation',
      description: 'Nous analysons les résultats de chaque campagne et optimisons continuellement notre approche pour améliorer les performances.'
    }
  ];

  return (
    <section className="py-20 bg-white relative z-0">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-growlyy-primary mb-4">Notre workflow</h2>
          <p className="text-xl text-growlyy-gray-dark max-w-2xl mx-auto">
            Un processus éprouvé pour générer des rendez-vous qualifiés
          </p>
        </div>

        <div className="relative">
          {/* Ligne de connexion */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-growlyy-gray -translate-y-1/2 z-1"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative z-2">
                <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 text-center h-full flex flex-col">
                  <div className="mx-auto bg-growlyy-secondary rounded-full w-16 h-16 flex items-center justify-center mb-4">
                    {step.icon}
                  </div>
                  <div className="bg-growlyy-primary text-white rounded-full w-8 h-8 flex items-center justify-center mx-auto -mt-12 mb-4 border-4 border-white">
                    {step.number}
                  </div>
                  <h3 className="text-xl font-semibold text-growlyy-primary mb-3">{step.title}</h3>
                  <p className="text-growlyy-gray-dark flex-grow">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bouton CTA */}
        <div className="text-center mt-16">
          <a href="https://zcal.co/adriengeen/15min" target="_blank" rel="noopener noreferrer" className="bg-growlyy-secondary text-white px-8 py-3 rounded-full font-medium hover:bg-growlyy-secondary-dark transition duration-300 text-lg shadow-md transform hover:scale-105 hover:-translate-y-1">
            Commencer maintenant
          </a>
        </div>
      </div>
    </section>
  );
};

export default Workflow; 